import React, { useRef, useEffect } from "react";
import { createConsumer } from "@rails/actioncable";

interface Props {
  textToSpeak?: string;
}

const cable = createConsumer("ws://localhost:3000/cable?token=12345");

const AudioStream: React.FC<Props> = ({ textToSpeak }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const mediaSourceRef = useRef<MediaSource | null>(null);
  const sourceBufferRef = useRef<SourceBuffer | null>(null);
  const subscriptionRef = useRef<any>(null);

  useEffect(() => {
    mediaSourceRef.current = new MediaSource();

    subscriptionRef.current = cable.subscriptions.create({ channel: "AudioChannel", stream_id: "stream_12345" }, {
      received: (data: { audio_chunk: string }) => {
        if (data?.audio_chunk) {
          const audioChunk = Uint8Array.from(atob(data.audio_chunk), c =>
            c.charCodeAt(0)
          );
          if (
            sourceBufferRef.current &&
            !sourceBufferRef.current.updating
          ) {
            sourceBufferRef.current.appendBuffer(audioChunk);
          }
        }
      },

      connected: (): void => {
        console.log("Connected to AudioChannel");
      }
    });

    mediaSourceRef.current.addEventListener("sourceopen", () => {
      try {
        const mimeCodec = "audio/mpeg";
        if (mediaSourceRef.current) {
          sourceBufferRef.current = mediaSourceRef.current.addSourceBuffer(
            mimeCodec
          );
        }
      } catch (err) {
        console.error("Error setting up source buffer", err);
      }
    });

    if (audioRef.current && mediaSourceRef.current) {
      audioRef.current.src = URL.createObjectURL(mediaSourceRef.current);
      audioRef.current.play().catch((err) => {
        console.warn("Autoplay prevented", err);
      });
    }

    return () => {
      subscriptionRef.current.unsubscribe();
    };
  }, []);

  useEffect(() => {
    console.log("Text to speak:", textToSpeak);
    if (textToSpeak && subscriptionRef.current) {
      subscriptionRef.current.send({ text: textToSpeak });
    }
  }, [textToSpeak]);

  return (
    <div>
      <audio ref={audioRef} controls/>
    </div>
  );
};

export default AudioStream;
